import { CLEAR_STATE } from '../types';

export const clearState = () => ({
  type: CLEAR_STATE,
});
